import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { map } from 'rxjs/operators';
import { arrayToTree } from 'performant-array-to-tree';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { MessagingService } from './messaging.service';

const token = localStorage.getItem('o3token');
const httpOptions = {
  headers: new HttpHeaders({
    Authorization: `Bearer ${token}`,
  }),
};
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  jwtHelper: any = new JwtHelperService();
  decodedToken: any;
  constructor(private http: HttpClient, private router: Router, private toaster: ToastrService, private messagingService: MessagingService) { }



  login(model: any): any {
    return this.http.post(this.O3CoreApiUrl + 'Auth/GetUserMEData', model).pipe(
      map((respose: any) => {
        const user = respose;
        if (!user.HasError) {
          if (user.Isloginsuccess) {
            localStorage.clear();
            localStorage.setItem('token', user.DeviceToken);
            localStorage.setItem('user', JSON.stringify(user));
            this.messagingService.getToken();
            this.toaster.success('Success', 'Login Successfully ');
          }
          else {
            this.showPopupMsg(user.ErrorMessage);

          }
          // 
          // localStorage.setItem('token', user.DeviceToken);
          // localStorage.setItem('result', JSON.stringify(user));
          // localStorage.setItem('user', JSON.stringify(user));
          // this.decodedToken = this.jwtHelper.decodeToken(user.token);
        }
      })
    );
  }

  loggedIn(): any {
    // tslint:disable-next-line: no-shadowed-variable
    const token = localStorage.getItem('auth_token');
    // const result = !this.jwtHelper.isTokenExpired(token);
    // return !this.jwtHelper.isTokenExpired(token);
    if (token !== null) {
      return true;
    } else { return false; }
  }
  isCustomerLogin(): boolean {
    const isAuthenticated = localStorage.getItem('auth_token');
    if (isAuthenticated == 'true') {
      return true;
    } else {
      return false;
    }
  }
  signUp(data: any): any {
    return this.http.post<any>(this.O3CoreApiUrl + 'signup', data, httpOptions);
  }
  showPopupMsg(msg: any): any {
    if (msg.substring(2, 1) === '0') {
      this.toaster.success('Success', msg.substring(3, msg.length));
    }
    else {
      this.toaster.error('Error', msg.substring(3, msg.length));
    }
  }

  getUserGroup(id: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'Users/Usergroup', id);
  }
  getUserRoles(id: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'Users/Rolesbyuser', id);
  }

  ForgotPasswordEmail(id: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'Users/ForgotPasswordEmail', id);
  }
  ForgotPasswordWhatsApp(id: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'Users/ForgotPasswordWhatsApp', id);
  }

  ValidateUserName(id: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'Users/ValidateUserName', id);
  }
  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.clear();
    this.decodedToken = null;
    this.router.navigate(['/login']);
  }
  GetMenuPermission(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Account/GetMenuPermission', data);
  }
}
